module.exports = __webpack_public_path__ + "img/google-play-badge.53feac5a.svg";